module.exports = __webpack_public_path__ + "static/hotel-42dd21f4597111530b5194468b2d6042.jpg";